import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import CouponTransfer from '../../entities/booking/couponTransfer';

interface CouponTransferState extends ListState<CouponTransfer>{
    editCouponTransfer:CouponTransfer
}
class CouponTransferModule extends ListModule<CouponTransferState,any,CouponTransfer>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<CouponTransfer>(),
        loading:false,
        editCouponTransfer:new CouponTransfer()
    }
    actions={
        async getAll(context:ActionContext<CouponTransferState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/CouponTransfer/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<CouponTransfer>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<CouponTransferState,any>,payload:any){
            await Ajax.post('/api/services/app/CouponTransfer/Create',payload.data);
        },
        async createWithImages(context:ActionContext<CouponTransferState,any>,payload:any){
            await Ajax.post('/api/services/app/CouponTransfer/CreateWithImages',payload.data);
        },
        async update(context:ActionContext<CouponTransferState,any>,payload:any){
            await Ajax.put('/api/services/app/CouponTransfer/Update',payload.data);
        },
        async updateWithImages(context:ActionContext<CouponTransferState,any>,payload:any){
            await Ajax.put('/api/services/app/CouponTransfer/UpdateWithImages',payload.data);
        },
        async delete(context:ActionContext<CouponTransferState,any>,payload:any){
            context.state.loading=true;
            await Ajax.delete('/api/services/app/CouponTransfer/Delete?Id='+payload.data.id);
            context.state.loading=false;
        },
        async get(context:ActionContext<CouponTransferState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/CouponTransfer/Get?Id='+payload.id);
            return reponse.data.result as CouponTransfer;
        }
    };
    mutations={
        setCurrentPage(state:CouponTransferState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:CouponTransferState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:CouponTransferState,couponTransfer:CouponTransfer){
            state.editCouponTransfer=couponTransfer;
        },
        changeLoading(state:CouponTransferState,pass:boolean){
            state.loading = pass;
        }
    }
}
const couponTransferModule=new CouponTransferModule();
export default couponTransferModule;